import { useParams } from 'react-router-dom';
import useManageTrainingRoute from '../../../hooks/useManageTrainingRoute';
import useQueryParams from '../../../hooks/useQueryParams';
import windowService from '../../../services/windowService';
import { sessionStorage } from '../../../utils/storageUtils';
import { useCourseBuilder } from './useCourseBuilder';
import { UrlParams } from '../models/url';
import { CourseStep } from '../models/course';

export const useCourseBuilderNavigation = () => {
  const { manageTrainingRoutePrefix } = useManageTrainingRoute();
  const { trainingId } = useParams<UrlParams>();

  const { course } = useCourseBuilder();
  const { workflowId } = useQueryParams({ preserveParams: true }) || {};

  const storedWorkflow = sessionStorage.getItem('pathway-builder_pathway');
  const isCurrentWorkflow = storedWorkflow?.id === workflowId;
  const workflowName = isCurrentWorkflow && storedWorkflow?.name;

  const workflowCrumbs = [
    { name: 'Church', route: '#/org' },
    { name: 'Manage Pathways', route: `#${manageTrainingRoutePrefix}/pathways` },
    {
      name: workflowName || 'Edit Pathway',
      route: `#${manageTrainingRoutePrefix}/pathways/${workflowId}`,
    },
    { name: course?.name || '' },
  ];

  const courseCrumbs = [
    { name: 'Church', route: '#/org' },
    { name: 'Manage Courses', route: `#${manageTrainingRoutePrefix}/courses` },
    { name: course?.name || '' },
  ];

  const crumbs = workflowId ? workflowCrumbs : courseCrumbs;

  const redirectToSettings = () => {
    windowService.redirectTo(
      `${manageTrainingRoutePrefix}/courses/${trainingId}/settings${workflowId ? `?workflowId=${workflowId}` : ''}`
    );
  };

  const redirectToStep = (step: CourseStep) => {
    const q = new URLSearchParams({ taskType: step._type });
    if (workflowId) q.set('workflowId', workflowId);
    windowService.redirectTo(`${manageTrainingRoutePrefix}/courses/${trainingId}?${q.toString()}`);
  };

  return {
    crumbs,
    redirectToSettings,
    redirectToStep,
  };
};
